import { AnonymousUserToken } from '../../AnonymousUserToken';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';

export class AmplifyFederatedSignInToken extends AnonymousUserToken {
    constructor(public provider: CognitoHostedUIIdentityProvider) {
        super();
    }
}
